import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { DefaultBackendPaymentData } from '@/shared/backend/paymentData';
import moduleUtils from '../moduleUtils';
import paymentMandate, {
  PaymentMandateData,
} from '@/shared/model/paymentMandateData';
import { AxiosResponse } from 'axios';
import { i18nGlobal } from '@/i18n';
import { BankDataState } from './types';
import { Logger } from 'fsts';
import paymentMandateHistoryEntry, {
  PaymentMandateHistoryEntry,
} from '@/shared/model/paymentMandateHistoryEntry';

const logger = new Logger('actions.bankData');
export const actions: ActionTree<BankDataState, RootState> = {
  getPaymentMandate({ commit }, applicationUserId: string) {
    commit('setBankDataIsLoading', true);
    return DefaultBackendPaymentData.getPaymentMandate(applicationUserId)
      .then((resp: AxiosResponse<PaymentMandateData>) => {
        const mandate = paymentMandate.parse(resp.data);
        commit('setBankDataPaymentMandate', mandate);
        return mandate;
      })
      .catch((e: any) => {
        const mandate = paymentMandate.parse();
        commit('setBankDataPaymentMandate', mandate);
        return mandate;
      })
      .finally(() => commit('setBankDataIsLoading', false));
  },
  updatePaymentMandate({ commit }, paymentMandate: PaymentMandateData) {
    commit('setBankDataIsLoading', true);
    return DefaultBackendPaymentData.updatePaymentMandate(paymentMandate)
      .then(() => {
        moduleUtils.ok(i18nGlobal.t(`success.paymentmandate_update`), commit);
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      })
      .finally(() => commit('setBankDataIsLoading', false));
  },
  getPaymentMandateHistory({ commit }, applicationUserId: string) {
    return DefaultBackendPaymentData.getPaymentMandateHistory(applicationUserId)
      .then((resp: AxiosResponse<PaymentMandateHistoryEntry[]>) => {
        const historyEntries = resp.data.map(paymentMandateHistoryEntry.parse);
        commit('setBankDataPaymentMandateHistory', historyEntries);
        return historyEntries;
      })
      .catch((e: any) => {
        commit('setBankDataPaymentMandateHistory', []);
        return [];
      });
  },
};
